





















































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import CheckboxGroupSlug from "../CheckboxGroupSlug.vue";
import { HEAD_TO_TOE_ROWS, HeadToToeRow } from "@/constants/geriatriOptions";
import { AsesmenGeriatriContent, HeadToToeKey, YaTidak } from "@/types/asesmen_geriatri";
import { ortostatikSaran, ortostatikSelisih } from "@/utils/geriatriScore";

@Component({ components: { CheckboxGroupSlug } })
export default class SectionPemeriksaanFisik extends Vue {
  @Prop({ default: () => ({}) }) readonly value!: AsesmenGeriatriContent["pemfis"];
  @Prop({ default: () => ({}) }) readonly penunjang!: AsesmenGeriatriContent["penunjang"];
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;

  panelTerbuka: number[] = [];

  get rows(): HeadToToeRow[] {
    return HEAD_TO_TOE_ROWS;
  }

  get saranOrtostatik(): YaTidak | null {
    return ortostatikSaran(this.value.tanda_vital);
  }

  get selisih() {
    return ortostatikSelisih(this.value.tanda_vital);
  }

  ikutiSaran() {
    this.$set(this.value.tanda_vital, "ortostatik_manual", this.saranOrtostatik);
  }

  ringkas(key: HeadToToeKey): string {
    const row = this.value.head_to_toe[key];
    if (!row) return "";
    const daftar: string[] = Array.isArray(row.temuan) ? row.temuan : [];
    if (!daftar.length) return row.catatan ? row.catatan : "";

    const katalog = HEAD_TO_TOE_ROWS.filter(r => r.key === key)[0];
    const label = daftar.map(slug => {
      const opsi = katalog.options.filter(o => o.key === slug)[0];
      return opsi ? opsi.label : slug;
    });

    return label.length > 2
      ? `${label[0]}, ${label[1]} +${label.length - 2}`
      : label.join(", ");
  }
}
